/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    return;

    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    /*****
     begin promos
     *****/
        // collect items to remove if they do not match requirements
    let itemsToRemove = {};
    let qualifiedPromoVariantIds = [];
    let selectablePromos = [];

    // keep track of items and add all at once
    let itemsToAdd = [];
    let discountsToApply = [];
    for (const promo of promos) {
        // check if any items have specific dates and/or qualify
        if (promo.start || promo.end) {
            const now = new Date().getTime();
            // check if there are start/end dates and if they apply
            if (promo.start) {
                const start = new Date(promo.start).getTime();
                if (!isNaN(start) && now < start) continue;
            }
            if (promo.end) {
                const end = new Date(promo.end).getTime();
                if (!isNaN(end) && now > end) continue;
            }
        }

        // check for further requirements
        let reqItems = [];
        let isProductRequirement = false;

        if (promo.products) {
            reqItems = promo.products.split(',');
            isProductRequirement = true;
        } else if (promo.variants) {
            reqItems = promo.variants.split(',');
        }

        const hasRequiredItems = reqItems.length > 0;

        // check if requirements are met
        // exclude promo items to prevent circular qualification
        let qualifiedPrice = 0;
        let qualifiedCount = 0;

        if (hasRequiredItems) {
            cart.items.forEach(item => {
                // skip promo items
                if (item.properties && item.properties['_promo'] === "true") return;
                const compareId = isProductRequirement ? item.product_id : item.variant_id;
                if (reqItems.includes(String(compareId))) {
                    qualifiedPrice += item.final_line_price;
                    qualifiedCount += item.quantity;
                }
            });
        } else {
            // calculate totals excluding promo items
            cart.items.forEach(item => {
                if (item.properties && item.properties['_promo'] === "true") return;
                qualifiedPrice += item.final_line_price;
                qualifiedCount += item.quantity;
            });
        }

        // qualification check
        const isMinMet = !promo.min || qualifiedPrice >= promo.min;
        const isNumMet = !promo.num || qualifiedCount >= promo.num;
        const hasAtLeastOne = !hasRequiredItems || qualifiedCount > 0;

        if (isMinMet && isNumMet && hasAtLeastOne) {
            // if passed these checks, we can add variants to cart
            const promoAdds = promo.promo_items.split(',');

            for (const promoAdd of promoAdds) {
                const [rawId, data] = promoAdd.split('-');
                const id = rawId ? rawId.trim() : rawId;
                if (!id) continue;

                // keep track of passing ids
                qualifiedPromoVariantIds.push(id);

                let quantity = 1;
                let sellingPlan = null;
                if (data) {
                    const [amt, plan] = data.split(':');
                    quantity = amt ? parseInt(amt, 10) : 1;
                    sellingPlan = plan ? parseInt(plan, 10) : null;
                }

                // only skip if a promo copy is already in the cart or itemsToAdd - a non-promo copy of the same variant should still get a promo version added
                if (!cart.items.find(item => String(item.variant_id) === id && item.properties && item.properties['_promo'] === "true") && !itemsToAdd.find(item => String(item.id) === id)) {
                    itemsToAdd.push({
                        id: parseInt(id, 10),
                        quantity: quantity,
                        selling_plan: sellingPlan,
                        // _promo flags the line for the Promo Discount app function to make it 100% off
                        properties: {
                            "_promo": "true"
                        }
                    });
                }
            }

            if (promo.code) discountsToApply.push(promo.code);

            // check on and add products with variant selection
            if (promo.promo_products) {
                // if empty, pass on
                if (promo.promo_products.length === 0) continue;
                for (let i = 0; i < promo.promo_products.length; i++) {
                    const promoProduct = promo.promo_products[i];
                    // add to qualified variants so they will stay in the cart
                    promoProduct.variants.forEach(variant => {
                        qualifiedPromoVariantIds.push(String(variant.id));
                    })
                    // check that product is not in the cart already
                    const productInCart = cart.items.find(item => item.product_id === promoProduct.id)
                    if (productInCart) continue;
                    // if not in the cart, add item to selectable products
                    selectablePromos.push(promoProduct);
                }
            }
        }
    }

    // if items are in cart that do not meet criteria and have _promo, remove
    cart.items.forEach(item => {
        // bundle gifts (_free_item) are managed by the bundle, not promo cleanup
        if (item.properties && item.properties['_free_item']) return;
        if (item.properties && item.properties['_promo'] === "true") {
            // free items by variant and product
            if (!qualifiedPromoVariantIds.includes(String(item.variant_id))) {
                itemsToRemove[item.key] = 0;
            }
        }
    });

    // remove any items that don't meet requirements
    if (Object.keys(itemsToRemove).length > 0) {
        await updateCart({updates: itemsToRemove});
        cart = await getCart();
    }

    // add promo variant items
    if (itemsToAdd.length > 0) {
        await addProduct({items: itemsToAdd});
        cart = await getCart();
    }

    // apply any discounts that may need manual adding
    if (discountsToApply.length > 0) {
        const activeCodes = cart.discount_codes.filter(item => item.applicable).map(item => item.code);

        discountsToApply.forEach(code => {
            if (!activeCodes.includes(code)) activeCodes.push(code);
        });

        await updateCart({discount: activeCodes.join(',')});
    }

    // remove previous runs of promo items
    document.querySelectorAll(".miniCartBodyPromoItem,.miniCartBodyPromoTitle")?.forEach(element => element.remove());
    if (selectablePromos.length > 0) {

        // add a title over items
        let promoTitle = `Select your gift${selectablePromos.length > 1 ? "s" : ""} with purchase.`;
        if (cartSettings.promo_type === "sample") {
            promoTitle = `Select your free sample${selectablePromos.length > 1 ? "s" : ""}.`;
        } else if (cartSettings.promo_type === "custom" && cartSettings.promo_title !== "") {
            promoTitle = cartSettings.promo_title;
        }
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `<div class="miniCartBodyPromoTitle">${promoTitle}</div>`)

        // add promo select product items to cart
        for (let i = 0; i < selectablePromos.length; i++) {
            const product = selectablePromos[i];

            // if no variants available, do not show promo for selection
            if (!product.available) continue;

            // create variant selection
            function variants() {
                let HTML = ``;
                product.variants.forEach((variant, index) => {
                    // do not even show any unavailable items
                    if (!variant.available) return;
                    HTML += `<option value="${variant.id}" ${index === 0 ? "selected" : ""}>${variant.title}</option>`;
                })
                return HTML;
            }

            // add variant selection element
            document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyPromoItem">
                <img class="miniCartBodyPromoItemImage" src="${product.featured_image}&width=200" alt="${product.title}">
                <div class="miniCartBodyPromoItemInner">
                   <div class="miniCartBodyPromoItemTitle">${product.title}</div>
                   <select name="variant" class="miniCartBodyPromoItemSelect">
                        ${variants()}
                    </select>
                    <button class="miniCartBodyPromoItemAtc button">ADD TO CART</button>
                </div>
            </div>
        `);
        }

        // add listeners to items
        document.querySelectorAll(".miniCartBodyPromoItemAtc").forEach(button => {
            button.addEventListener("click", async function () {
                // get selected variant
                const variant = parseInt(this.previousElementSibling.value, 10);
                if (!variant) return;
                // add the variant to cart
                await addProduct({
                    items: [{
                        quantity: 1,
                        id: variant,
                        properties: {
                            "_promo": "true"
                        }
                    }]
                });
                await openCart();
            });
        })
    }

    /*****
     end promos
     *****/

    // check for protection or sample and remove if the only item
    if (cart.item_count === 1 && cart.items.find(el => el.product_id === parseInt(cartSettings?.sample_product?.id) || el.product_id === 8503316447383)) {
        // remove the protection or the sample product
        cart = await updateCart({
            updates: {
                [cart.items[0].variant_id]: 0
            }
        });
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    // update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderCount").textContent = cart.item_count > 0 ? `${cart.item_count} item${cart.item_count > 1 ? "s" : ""}` : "";

    // check that the shipping section exists
    const shipping = document.querySelector("#miniCartShipping");

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        if (shipping) {
            shipping.classList.remove("active");
        }
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        if (document.querySelector("#miniCartEuShipping")) {
            document.querySelector("#miniCartEuShipping").classList.remove("active");
        }
        return;
    }

    // show main cart sections
    if (shipping) {
        shipping.classList.add("active");
    }
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");
    if (document.querySelector("#miniCartEuShipping")) {
        document.querySelector("#miniCartEuShipping").classList.add("active");
    }

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription" && shipping) {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartShippingText").innerHTML = "You've qualified for free standard US shipping";
        } else {
            document.querySelector("#miniCartShippingText").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
        }
    }

    // Free shipping for price threshold - also uses subscription for free shipping
    if (cartSettings.free_shipping_method === "threshold" && shipping) {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartShippingText").innerHTML = "You've qualified for free standard US shipping";
            document.querySelector("#miniCartShippingBar").classList.add("active");
        } else if (subscriptionItems > 0) {
            document.querySelector("#miniCartShippingText").innerHTML = "You've qualified for free standard US shipping";
            document.querySelector("#miniCartShippingBar").classList.add("active");
        } else {
            document.querySelector("#miniCartShippingText").innerHTML = `${price(freeShippingThreshold - cart.total_price)} away from free standard US shipping`;
            document.querySelector("#miniCartShippingBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartShippingBar").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem,.miniCartBodyBundle").forEach(element => element.remove());

    // create a storage for any bundles
    const bundles = {}

    // append cart
    cart.items.forEach(function (item) {

        // if complimentary item or protection item is in cart, skip item
        if (item.product_id === parseInt(cartSettings?.sample_product?.id) || item.product_id === 8503316447383) return;

        // if item has timestamp, sort by group
        if (item.properties._group) {
            if (bundles[item.properties._group]) {
                bundles[item.properties._group].push(item);
            } else {
                bundles[item.properties._group] = [item];
            }
            return;
        }

        // save supplement data
        const supplementData = cartData[item.key];

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                if (key === "_preorder") {
                    HTML += `<span class="miniCartBodyItemPropertiesPre">PRE-ORDER</span>`;
                    continue;
                }
                if (key.includes("_")) continue;
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.final_line_price === 0) {
                return ``;
            } else if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return `<div class="miniCartBodyItemSellingPlan">ONE TIME PURCHASE</div>`;
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML = `<span class="miniCartBodyItemPriceCompare">${price(greatestComparePrice)}</span>` + HTML;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if selling plan exists
            if (!supplementData["selling_plan_id"]) {
                return "";
            }

            // check if hidden plan
            if (supplementData["selling_plan_name"] === "Smartrr Add-On Subscription Program") {
                return "";
            }

            // return HTML
            return `
                <button
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}"
                     data-plan="${supplementData["selling_plan_id"]}"
                >
               ${supplementData["selling_plan_text"] ? supplementData["selling_plan_text"] : supplementData["selling_plan_name"]}
                </button>
            `;
        }

        // return empty quantity selector if the item is free
        function quantity() {
            if (item.final_line_price === 0) {
                return ``
            }
            return `
                        <div class="miniCartBodyItemQuantity">
                            <button type="button" class="miniCartBodyItemQuantityMinus" aria-label="Decrease quantity for ${item.product_title}">
                                <svg aria-hidden="true" focusable="false" viewBox="0 0 32 32">
                                    <path fill="" d="M32,14.477v3.047H0v-3.047H32z"></path>
                                </svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button type="button" class="miniCartBodyItemQuantityPlus" aria-label="Increase quantity for ${item.product_title}">
                                <svg aria-hidden="true" focusable="false" viewBox="0 0 32 32">
                                    <path fill="" d="M17.524,17.524H32v-3.048H17.524V0h-3.048v14.476H0v3.048h14.476V32h3.048V17.524z"></path>
                                </svg>
                            </button>
                        </div>
                `
        }

        // no remove for gifts
        function removeButton() {
            if (item.final_line_price === 0) {
                return ``;
            }
            return `
                <button type="button" class="miniCartBodyItemRemove" aria-label="Remove ${item.product_title} from cart">
                  <svg aria-hidden="true" focusable="false" tabindex="-1" role="presentation" viewBox="0 0 32 32">
                      <path fill="" d="M30.5,5.8h-2.9h-2l-1.6-3.3c-0.4-0.7-0.9-1.4-1.6-1.8C21.8,0.2,21,0,20.1,0h-8.3C11,0,10.2,0.2,9.5,0.7 C8.8,1.1,8.3,1.8,7.9,2.5L6.4,5.8h-2H1.5C0.7,5.8,0,6.5,0,7.3s0.7,1.5,1.5,1.5h1.6l2.2,19.4c0.1,1.1,0.6,2.1,1.4,2.8 C7.4,31.6,8.5,32,9.6,32h12.9c1.1,0,2.1-0.4,2.9-1.1c0.8-0.7,1.3-1.7,1.4-2.8l2.2-19.4h1.6c0.8,0,1.5-0.7,1.5-1.5S31.3,5.8,30.5,5.8 z M10.5,3.7c0.1-0.2,0.3-0.5,0.5-0.6c0.2-0.1,0.5-0.2,0.8-0.2h8.3c0.3,0,0.5,0.1,0.8,0.2c0.2,0.1,0.4,0.4,0.5,0.6l1,2.1H9.6 L10.5,3.7z M23.9,27.8c0,0.4-0.2,0.7-0.5,0.9c-0.3,0.2-0.6,0.4-1,0.4H9.6c-0.4,0-0.7-0.1-1-0.4c-0.3-0.2-0.4-0.6-0.5-0.9L6,8.7h1.3 h17.5H26L23.9,27.8z M14.5,14.5v7.3c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5v-7.3c0-0.8,0.7-1.5,1.5-1.5 C13.9,13.1,14.5,13.7,14.5,14.5z M20.4,14.5v7.3c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5v-7.3c0-0.8,0.7-1.5,1.5-1.5 C19.7,13.1,20.4,13.7,20.4,14.5z"></path>
                  </svg>
                </button>
`
        }

        // return message with gifts
        function message() {
            if (item.final_line_price === 0) {
                return `<div class="miniCartBodyItemMessage">(Gift with purchase)</div>`
            }
            return ``;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <a href="${item.url}">
                    <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                </a>
                <div>
                    <div class="miniCartBodyItemFlex ${item.final_line_price !== 0 ? "addMargin" : ""}">
                        <div>
                            ${variantHTML()}
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${propertiesHTML()}
                            ${message()} 
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    ${subscriptionHTML()}
                    <div class="miniCartBodyItemFlex">
                        ${quantity()}
                        ${removeButton()}
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = 0;
        if (element.querySelector(".miniCartBodyItemQuantityCount")) {
            quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);
        }

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus")?.addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus")?.addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart();
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.parentElement.style.display = "none"
            element.classList.remove('active');
        } else {
            element.parentElement.style.display = "block"
            element.classList.add('active');
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    } else {
        // update the swiper in case slides have been hidden
        upsellSwiper.update();
    }

    // check for bundles
    if (Object.keys(bundles).length > 0) {
        // create a visual item for each bundle
        Object.keys(bundles).forEach(key => {
            // collect items for bundle
            function images() {
                let images = ``;
                bundles[key].forEach(item => {
                    images += `
                            <img class="miniCartBodyBundleCollageItem ${item.properties._free_item ? "freeItem" : ""}"
                             src="${item.image}"
                             alt="${item.title}">
                            `
                })
                return images;
            }

            function priceTotal() {
                let priceTotal = 0;
                bundles[key].forEach(item => {
                    if (item.properties._free_item) return;
                    priceTotal += item.price
                })
                return price(priceTotal);
            }

            function lineItems() {
                let body = ``;
                bundles[key].forEach(item => {
                    if (item.properties._free_item) {
                        body += `
                        <div class="miniCartBodyBundleInnerGroupItem freeItem">
                            <img class="miniCartBodyBundleInnerGroupItemImage"
                                 src="${item.image}"
                                 alt="${item.title}">
                            <div class="miniCartBodyBundleInnerGroupItemStack">
                                <span>${item.product_title}</span>
                                <span class="miniCartBodyBundleInnerGroupItemStackFree">(FREE BUNDLE GIFT)</span>
                            </div>
                        </div>    
                            `
                    } else {
                        body += `
                        <div class="miniCartBodyBundleInnerGroupItem">
                            <img class="miniCartBodyBundleInnerGroupItemImage"
                                 src="${item.image}"
                                 alt="${item.title}">
                            <div class="miniCartBodyBundleInnerGroupItemFlex">
                                <span>${item.product_title}</span>
                                <span class="miniCartBodyBundleInnerGroupItemFlexLast">${item.variant_title}</span>
                            </div>
                        </div> 
                        `
                    }
                })
                return body;
            }

            // build element
            document.querySelector("#miniCartBody").insertAdjacentHTML("afterbegin", `
                    <div class="miniCartBodyBundle">
                        <div class="miniCartBodyBundleCollage">
                            ${images()}
                        </div>
                        <div class="miniCartBodyBundleInner">
                            <div class="miniCartBodyBundleInnerTop">
                                <span class="miniCartBodyBundleInnerTopText">Your bundle</span>
                                <span class="miniCartBodyBundleInnerTopPrice">${priceTotal()}</span>
                            </div>
                            <div class="miniCartBodyBundleInnerGroup">
                                ${lineItems()}
                            </div>
                            <button class="miniCartBodyBundleInnerButton" 
                            data-group="${bundles[key][0].properties._group}" 
                            aria-label="remove the bundle">Remove</button>
                        </div>
                    </div>
                `)
        })

        // add remove listener
        document.querySelectorAll('.miniCartBodyBundleInnerButton')?.forEach(button => {
            button.addEventListener('click', async function () {
                let updatePayload = {};

                // remove vitamin d+k if in cart
                const freeGifts = cart.items.filter(item => item.properties._group === parseInt(this.dataset.group));
                if (freeGifts.length > 0) {
                    // get all protection items
                    freeGifts.forEach(item => {
                        updatePayload[item.key] = 0;
                    });
                }

                // check if we need to update the cart
                if (Object.keys(updatePayload).length > 0) {
                    cart = await updateCart({updates: updatePayload});
                    await openCart();
                }
            })
        })
    }

    // update the subtotal price
    document.querySelector("#miniCartFooterPrice").innerHTML = `<span>Subtotal</span>${price(cart.items_subtotal_price)}`;

    // if there is an EU shipping warning, check that the shipping threshold has been reached
    if (euWarning) {
        // gather the exchange rate and converted cart total
        const threshold = Number(euWarning?.dataset?.threshold) || 0;
        const exchangeRate = await getEuroExchangeRate();
        // if rate is not found, let checkout proceed
        if (exchangeRate) {
            // compare the converted limit and total
            const convertedCartTotal = Math.floor(cart.items_subtotal_price * exchangeRate);
            const thresholdReached = convertedCartTotal >= threshold;
            // if the limit is surpassed, we can remove blocks on the checkout messaging
            euWarning.classList.toggle('active', !thresholdReached);
            document.querySelector('#miniCartFooterBottom').classList.toggle('disabled', !thresholdReached);
        } else {
            euWarning.classList.remove('active');
            document.querySelector('#miniCartFooterBottom').classList.remove('disabled');
        }
    }
}

// euWarning element
const euWarning = document.querySelector('#miniCartEuShippingWarning');

// function for getting and storing exchange rate
async function getEuroExchangeRate() {
    // try the rate from session, else fetch and store it for the session to limit calls
    let rate = parseFloat(sessionStorage.getItem('eur_rate')) || null;
    if (!rate) {
        try {
            const data = await fetch(`https://api.frankfurter.dev/v2/rates?base=USD&quotes=EUR`)
            const dataItem = await data.json();
            // returns an array and the rate on object is already a float
            rate = dataItem[0].rate;
            if (rate) {
                sessionStorage.setItem('eur_rate', `${rate}`);
            }
        } catch (err) {
            console.log(err, "Exchange rate fetch failed");
            return null;
        }
    }
    return rate;
}

// upsell items swiper
const upsellSwiper = new Swiper(document.querySelector("#miniCartUpsellInner"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        prevEl: document.querySelector("#miniCartUpsellInner .swiper-button-prev"),
        nextEl: document.querySelector("#miniCartUpsellInner .swiper-button-next")
    }
});

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});

// open/close note container
if (document.querySelector(`.miniCartFooterSampleInput[name="note"]`) && document.querySelector(`#miniCartFooterNoteForm`)) {
    document.querySelector(`.miniCartFooterSampleInput[name="note"]`).addEventListener("change", async function () {
        if (this.checked) {
            document.querySelector(`#miniCartFooterNote`).classList.add("active");
        } else {
            // hide and empty note
            document.querySelector(`#miniCartFooterNote`).classList.remove("active");
            cart = await updateCart({
                note: "",
            });
            document.querySelector(`#miniCartFooterNoteForm`).value = "";
        }
    })
    // add note on content entry
    document.querySelector(`#miniCartFooterNoteForm`).addEventListener("blur", async function () {
        cart = await updateCart({
            note: this.value,
        });
    })
}

// discount code add
if (document.querySelector('#miniCartFooterDiscount')) {

    // on load, check for empty wrap and hide
    if (document.querySelector('.miniCartFooterDiscountCodeWrap.active') && !document.querySelector('.miniCartFooterDiscountCode')) {
        document.querySelector('.miniCartFooterDiscountCodeWrap.active').classList.remove("active");
        document.querySelector('#miniCartFooterDiscount').classList.add("active");
    }

    document.querySelector('#miniCartFooterDiscount').addEventListener("submit", async function (e) {
        e.preventDefault();
        const inputValue = this.querySelector('#miniCartFooterDiscountInput').value;
        if (inputValue) {
            let discounts = ""
            cart.discount_codes.forEach((item) => {
                if (item.applicable === true) {
                    discounts += `${item.code},`
                }
            })
            discounts += inputValue;
            try {
                cart = await updateCart({discount: discounts})
                // if successful, hide the input and add code
                document.querySelector('.miniCartFooterDiscountCodeWrap').classList.add('active');
                document.querySelector('#miniCartFooterDiscount').classList.remove('active');
                await openCart();
            } catch (error) {
                console.error(error)
            }
        }
    })
}

// discount removal
if (document.querySelector('.miniCartFooterDiscountCodeClose')) {
    document.querySelectorAll('.miniCartFooterDiscountCodeClose').forEach(el => {
        el.addEventListener("click", async function () {
            try {
                cart = await updateCart({discount: ""});
                // if successful, hide the code and show the input
                document.querySelector('.miniCartFooterDiscountCodeWrap').classList.remove('active');
                document.querySelector('#miniCartFooterDiscount').classList.add('active');
                await openCart();
            } catch (error) {
                console.error(error)
            }
        })
    })
}

// add complimentary product
if (document.querySelector('.miniCartFooterSampleInput[name="sample"]')) {
    document.querySelector('.miniCartFooterSampleInput[name="sample"]').addEventListener("change", async function () {
        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");
        // add product
        if (this.checked) {
            // formdata
            let formData = {
                items: [{
                    quantity: 1,
                    id: cartSettings.sample_product.variants[0].id,
                    properties: {
                        '_free_sample': true
                    }
                }]
            };

            await addProduct(formData);
        } else {
            // remove product
            let updatePayload = {};

            // get the complementary item
            cart.items.forEach(item => {
                if (item.variant_id === cartSettings.sample_product.variants[0].id) {
                    updatePayload[item.key] = 0;
                }
            });

            cart = await updateCart({updates: updatePayload});
        }
        // start loading animation
        document.querySelector("#miniCartContent").classList.remove("loading");
        await openCart();
    })
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart().catch(err => console.error(err));
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
if (document.querySelector('#miniCartFooterCheckout')) {
    document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
        // go to checkout
        window.location.href = `${Shopify.routes.root}checkout`;
    });
}

// this is used when the miniCartFooterCheckoutProtection needs to fall back when not applicable (gift cards)
function goToCheckout() {
    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
}

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}